/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Campaignservicev1Note } from '../models/Campaignservicev1Note';
import { HttpFile } from '../http/http';

/**
* pauses an orderline
*/
export class PauseOrderLineRequest {
    'orgId': string;
    'note'?: Campaignservicev1Note;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "note",
            "baseName": "note",
            "type": "Campaignservicev1Note",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return PauseOrderLineRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

